export const SIDE_BAR = 'side_bar';
export const TOP_BAR = 'top_bar';
export const LOGINPAGE = 'loginpage';
export const REG_PAGE = 'reg_page';
export const SWITCHTOREG = 'switch_reg';
export const SWITCHTOLOGIN = 'switch_login';
export const RECOVER_PASS = 'recover_pass';